import { render } from "./trust-data-trust-team.html?vue&type=template&id=b1364bb0&scoped=true&ts=true&external"
import script from "./trust-data-trust-team.ts?vue&type=script&lang=ts&external"
export * from "./trust-data-trust-team.ts?vue&type=script&lang=ts&external"

import "./trust-data-trust-team.scss?vue&type=style&index=0&id=b1364bb0&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1364bb0"]])

export default __exports__